import _classCallCheck from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import _objectSpread from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import React from 'react';
import store from '../../store';
import STORE_KEY from '../../store/constants';
import ACTIONS from '../../store/actions';
import { createProvider } from 'react-redux';
import DateTimeProvider from './DateTimeProvider';
import ThemeProvider from '../../theme/ThemeProvider';
import DataGridProvider from '../../data/Grid/Provider';
import PageProvider from '../../page/Provider';
import Guide from '../Guide';
import { addDataType } from '../../data';
import Utils from '../../utils';
import modals from '../../modal';
import ModalRoot from '../../modal/ModalRoot';
import Bootstrap from './boot/Bootstrap';
import ErrorBoundary from './ErrorBoundary';
import ErrorCloudInstanceMissing from './ErrorCloudInstanceMissing';
import { configure } from 'react-hotkeys';
configure({
  ignoreTags: ['input', 'select', 'textarea', 'button']
});
var ReduxProvider = createProvider(STORE_KEY);
export var EcrionProviderContext = React.createContext({});
/**
 * @param {import('./types').EcrionProviderProps} props
 * @returns {import('./types').EcrionProviderProps}
 */

var enhanceProps = function enhanceProps(props) {
  return _objectSpread({}, props, {
    microservice: enhanceMicroserviceProp(props),
    settings: enhanceSettingsProp(props)
  });
};

var DEFAULT_MICROSERVICE_SETTINGS = {
  requiresCloudInstance: true,
  requiresLicensing: false,
  requiresInstallation: false
};

var enhanceMicroserviceProp = function enhanceMicroserviceProp(_ref) {
  var microservice = _ref.microservice;
  if (!microservice) return {};
  if (typeof microservice === 'string') return _objectSpread({}, DEFAULT_MICROSERVICE_SETTINGS, {
    id: microservice
  });

  var microserviceObj = _objectSpread({}, DEFAULT_MICROSERVICE_SETTINGS, microservice);

  var requiresLicensing = microserviceObj.requiresLicensing;
  if (typeof requiresLicensing === 'boolean' && requiresLicensing) microserviceObj.requiresLicensing = {};
  var requiresInstallation = microserviceObj.requiresInstallation;
  if (typeof requiresInstallation === 'boolean' && requiresInstallation) microserviceObj.requiresInstallation = {};
  return microserviceObj;
};

var DEFAULT_SETTINGS = {
  integrations: {
    crm: false
  },
  forms: {
    emailBlackList: false,
    googleApiKey: false,
    peopleMergeRules: false
  },
  email: false,
  tracking: false
};

var enhanceSettingsProp = function enhanceSettingsProp(_ref2) {
  var settings = _ref2.settings;
  if (!settings) return DEFAULT_SETTINGS;
  return _objectSpread({}, DEFAULT_SETTINGS, settings);
};
/**
 * @extends {React.Component<import('./types').EcrionProviderProps>}
 * Provides context for all smart components including theme,
 * a global store, and access to remote data models in a normalized way.
 *
 * Render this at the top level, with the entire app's component tree inside of it. */


var EcrionProvider =
/*#__PURE__*/
function (_React$Component) {
  _inherits(EcrionProvider, _React$Component);

  function EcrionProvider(props) {
    var _this;

    _classCallCheck(this, EcrionProvider);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(EcrionProvider).call(this, props));

    _this.getContext = function () {
      return enhanceProps(_this.props);
    };

    var eProps = _this.getContext(props);

    _this.auth = Utils.auth.initialize({
      routes: eProps.routes,
      microserviceId: eProps.microservice.id,
      disableAuthRedirect: eProps.disableAuthRedirect
    });
    _this.state = {
      showMissingCloudInstanceError: false
    };

    if (eProps.microservice.requiresCloudInstance && !_this.auth.data.ecrionServer) {
      _this.state.showMissingCloudInstanceError = true;
      return _possibleConstructorReturn(_this);
    }

    store.dispatch({
      type: ACTIONS.AUTH_SET,
      payload: _this.auth.data
    });
    if (eProps.dataTypes) addDataType(eProps.dataTypes);
    if (eProps.modals) modals.register(eProps.modals);
    return _this;
  }

  _createClass(EcrionProvider, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.auth.cleanup();
    }
  }, {
    key: "render",
    value: function render() {
      var props = this.getContext();
      var ErrorBoundaryComponent = props.renderFallbackOnError ? ErrorBoundary : React.Fragment;
      return React.createElement(EcrionProviderContext.Provider, {
        value: props
      }, React.createElement(ReduxProvider, {
        store: store
      }, React.createElement(ThemeProvider, {
        theme: props.theme
      }, React.createElement(PageProvider, null, React.createElement(ErrorBoundaryComponent, null, React.createElement(DateTimeProvider, null, React.createElement(DataGridProvider, null, React.createElement(React.Fragment, null, React.createElement(ModalRoot, null), this.state.showMissingCloudInstanceError ? React.createElement(ErrorCloudInstanceMissing, null) : React.createElement(Bootstrap, null, React.createElement(Guide, {
        guide: props.guide
      }), props.children)))))))));
    }
  }]);

  return EcrionProvider;
}(React.Component);

EcrionProvider.defaultProps = {
  microservice: null,
  renderFallbackOnError: true
};
export default EcrionProvider;